import { BrowserRouter } from 'react-router-dom';
import './App.css';
import './assets/css/bannerSVG.css';
import './assets/css/resultPage.css';
import { AppRouter } from './router/routes';



function App() {
  return <>

    <BrowserRouter>
      <AppRouter />
    </ BrowserRouter>

  </>
}


export default App;